import type { LineItemLot } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { LotBadge } from "../wms/shared/lot-badge";

export const LineItemLots = memo(function LineItemLots({
  lots,
  label = "Lots",
}: {
  lots: LineItemLot[] | undefined;
  label?: string;
}) {
  if (!lots?.length) {
    return null;
  }
  return (
    <Flex align="center" gap="xs" style={{ flexWrap: "wrap", rowGap: 4 }}>
      <Text fontSize="xxs" textColor="tertiary">
        {label}:
      </Text>
      {lots.map((lot, i) => (
        <LotBadge
          expirationDate={lot.expirationDate}
          key={`${lot.lotNumber ?? ""}-${i}`}
          lotNumber={lot.lotNumber ?? "—"}
          quantity={lot.quantity}
          size="xs"
        />
      ))}
    </Flex>
  );
});
